import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'completed-resume',
    templateUrl: './completed.resume.component.html',
    styleUrls: ['./../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedResumeComponent {
    @Input('subtotal') subtotal: number;
    @Input('discount') discount: number;
    @Input('freight') freight: number;
    @Input('freight_per_billing_cycle') freight_per_billing_cycle: number;
    @Input('total') total: number;
    @Input('deliverable') deliverable: boolean;
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/completed/resume/completed.resume.component.ts